import * as React from 'react';
import { memo } from 'react';

import styled from 'styled-components';

import { Button } from 'atoms';
import { PopupContainer } from 'molecules';

import { Colors } from 'services/ColorService';
import { getFontFamily } from 'services/FontService';
import { transFormAlignProp } from 'services/TransformService';
import { PublishedLmsType } from 'types';
import { useTranslation } from 'react-i18next';

export interface IAddGroupInLMSPopup extends IAddGroupInLMSPopupStyle {
  onClose: () => void;
  onConfirm: () => void;
  groupName: string;
  publishedLmsType?: PublishedLmsType;
}

export interface IAddGroupInLMSPopupStyle {
  width?: string;
}

export const AddGroupInLMSPopupComponent = memo(
  ({
    onClose,
    onConfirm,
    width,
    groupName,
    publishedLmsType,
  }: IAddGroupInLMSPopup) => {
    const { t } = useTranslation();
    return (
      <PopupContainer
        title={t('publishGroupPopup.publishLms')}
        width={width}
        onClose={onClose}
      >
        <WrapperText>
          <Text>
            {t('publishGroupPopup.youAreGoingToPublish')} “
            <BoldText>{groupName}</BoldText>”
            {publishedLmsType === PublishedLmsType.methodist
              ? t('publishGroupPopup.ifYouConfirmMethodist')
              : publishedLmsType === PublishedLmsType.teacher
              ? t('publishGroupPopup.ifYouConfirmTeacher')
              : t('publishGroupPopup.ifYouConfirmStudent')}
          </Text>
        </WrapperText>

        <WrapperRow align="right">
          <WrapperDeleteButton>
            <Button
              onClick={onClose}
              variant="outline"
              colors={{
                backgroundColor: Colors.White,
                color: Colors.Blue,
              }}
            >
              {t('publishGroupPopup.button.cancel')}
            </Button>
          </WrapperDeleteButton>

          <WrapperSendButton>
            <Button
              onClick={onConfirm}
              colors={{
                backgroundColor: Colors.Blue,
                color: Colors.White,
              }}
            >
              {t('publishGroupPopup.button.publish')}
            </Button>
          </WrapperSendButton>
        </WrapperRow>
      </PopupContainer>
    );
  },
);

const WrapperRow = styled.div<{
  margin?: string;
  wrap?: boolean;
  align?: 'left' | 'right' | 'center';
}>`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  align-items: ${({ align }) => (align ? transFormAlignProp(align) : 'center')};
  flex-wrap: ${({ wrap }) => (wrap ? 'wrap' : 'nowrap')};
  margin: ${({ margin }) => margin || 'initial'};
`;

const WrapperText = styled.div`
  margin: 0 0 32px 0;
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
`;

const WrapperDeleteButton = styled.div`
  margin: 0 16px 0 auto;
  width: 122px;
`;

const WrapperSendButton = styled.div`
  width: 199px;
`;

const BoldText = styled.span`
  font-family: ${getFontFamily('bold')};
`;

const Text = styled.p`
  margin-top: 24px;
  font-family: ${getFontFamily('medium')};
  font-size: 14px;
  line-height: 24px;
  font-weight: 500;
`;
